import { Grid } from '@mui/material';

import { type ThemaFromThemaRouter } from '../../dtos';
import { CreateVeranstaltung } from './CreateVeranstaltung';
import { VeranstaltungPlanungHeader } from './VeranstaltungPlanungHeader';
import { VeranstaltungPlanungSidebar } from './VeranstaltungPlanungSidebar';

type VeranstaltungPlanungProps = {
  readonly thema: ThemaFromThemaRouter;
};

export const VeranstaltungPlanung = ({ thema }: VeranstaltungPlanungProps) => (
  <Grid container spacing={2}>
    <VeranstaltungPlanungHeader thema={thema} />
    <Grid size={{ xs: 12 }} container spacing={2}>
      <Grid sx={{ width: 320, flexShrink: 0 }}>
        <VeranstaltungPlanungSidebar thema={thema} />
      </Grid>
      <Grid sx={{ flex: 1, minWidth: 0 }}>
        <CreateVeranstaltung thema={thema} />
      </Grid>
    </Grid>
  </Grid>
);
